const LAUNCH_TEST_HOSTS = new Set([
  "spicenet-portal-launch-test.vercel.app",
  "spicenet-portal-git-reppo-campaign-wallet-linking-spicenet.vercel.app",
]);

export const isLaunchTestPreview = () => {
  if (typeof window === "undefined") return false;
  return LAUNCH_TEST_HOSTS.has(window.location.hostname);
};
